import { render } from "./BreakdownComponent.vue?vue&type=template&id=46fc064e&ts=true"
import script from "./BreakdownComponent.vue?vue&type=script&lang=ts"
export * from "./BreakdownComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__